module.exports = __webpack_public_path__ + "static/media/2_en.9d54da90.png";